import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ConfigResourceService } from '@mri/app/resources';
import { map, Subscription, tap } from 'rxjs';

const dasharrayMax = 614;

@Component({
  selector: 'app-speedometer',
  templateUrl: './speedometer.component.html',
  styleUrls: ['./speedometer.component.scss']
})
export class SpeedometerComponent implements OnInit, OnDestroy {

  private _value: number;
  private _sub = new Subscription();

  speedShow: number;
  color: string = '#ccc';
  unitMultiply: number;
  @Input() multiply: number = 15;
  @Input() unitLabel: string = 'Km/h';

  @Input({ required: true })
  set value(value: number) {
    this._value = value;
    this.speedShow = value * this.unitMultiply;
    this._updateStroke();
  }

  get value(): number {
    return this._value * this.unitMultiply;
  }

  get lines(): number[] {
    return [...new Array(9).keys()].map(n => (n) * this.multiply);
  }

  get maxSpeed() {
    return this.multiply * 8;
  }

  constructor(
    private _configSrc: ConfigResourceService
  ) {
  }

  ngOnInit() {
    this._updateStroke();
    this._sub.add(
      this._configSrc.getCalcVars()
        .pipe(
          map(vars => vars?.speedUnit),
          tap( unit => this.unitMultiply = unit?.multiply ?? this.unitMultiply),
          tap( unit => this.unitLabel = unit?.abbr ?? this.unitLabel),
        )
        .subscribe()
    );

    setTimeout(() => this._updateStroke(), 500);
  }

  ngOnDestroy() {
    this._sub.unsubscribe();
  }

  private _updateStroke() {
    const value = this.value;

    const maxSpeed = this.multiply * 8;
    const compareValue = maxSpeed < value ? maxSpeed : value;

    const percentage = (compareValue / maxSpeed);
    const dasharray = dasharrayMax * percentage;
    const element = document.querySelector('#meter-bg-bar');

    this.color = this._getColor();

    if (!element) return;

    element.setAttribute('style', `stroke-dashoffset: ${dasharrayMax - parseInt(dasharray.toString())}`);
    element.setAttribute('stroke', this.color);
  }

  private _getColor() {
    const percentage = this.value / this.maxSpeed;

    if (percentage < 1 / 3 * 2) return '#02b502';
    if (percentage < 10 / 12) return '#bfb006';
    return '#d33b05';
  }

}
